import sortFunc from "Utils/sortFunc";
import { shortenLabels } from "Config/chartjs.global";
import config from "Config";

const generateComparisonChartDataset = (d, sortColumn) => {
  if (Object.keys(d).length === 0) return null;

  const labels = [...new Set(d["rows"].map((r) => r[sortColumn]))];

  const shortenedLabels = labels.map((label) => shortenLabels(label));

  const state_rows = d["rows"]
    .filter((r) => r["community"] === config.admin_state_name)
    .sort((a, b) => sortFunc(labels, a, b, sortColumn));
  const community_rows = d["rows"]
    .filter((r) => r["community"] !== config.admin_state_name)
    .sort((a, b) => sortFunc(labels, a, b, sortColumn));

  const datasets = [
    {
      label: community_rows[0]["community"],
      data: community_rows.map(({ percentage }) => percentage),
      figureValues: community_rows.map(({ number }) => number),
      backgroundColor: "#4372C4",
    },
    {
      label: state_rows[0]["community"],
      data: state_rows.map(({ percentage }) => percentage),
      figureValues: state_rows.map(({ number }) => number),
      backgroundColor: "#ED7D31",
    },
  ];

  return { labels: shortenedLabels, datasets };
};

export default generateComparisonChartDataset;



// WEBPACK FOOTER //
// ./utils/generateComparisonChartDataset.js